import { createSlice } from "@reduxjs/toolkit";
import { MODULE_COLUMNS } from "../../constant/data";
import { sortAllView } from "../utils";
import { boardViewForAllocation } from "./TransferOrderSliceV2";

const productCategoryDefaultColumns = [
  "NAME",
  "SHORT DESCRIPTION",
  "LONG DESCRIPTION",
  "CREATED BY",
  "CREATE DATE",
  "PARENT CATEGORY",
  "CATEGORY STATUS",
];
const productTagDefaultColumns = ["NAME", "SHORT DESCRIPTION", "CREATED BY", "TAG STATUS"];
const productAliasDefaultColumns = [
  "NAME",
  "NUMBER",
  "PRODUCT",
  "FACILITY",
  "SUPPLIER",
  "CREATED BY",
  "CREATE DATE",
];
const productPlanDefaultColumns = [
  "PRODUCT",
  "ACQUISITION TYPE",
  "SUPPLIER",
  "FROM FACILITY",
  "TO FACILITY",
  "PICK LOCATION",
  "REPLENISHMENT METHOD",
  "REPLENISHMENT QUANTITY",
  "ACTIVITY LOG",
  "TRIGGER QUANTITY",
  "MAX STOCK QUANTITY",
  "PLANNING POLICY",
  "REORDER POINT METHOD",
  "REORDER POINT DAYS",
  "REORDER POINT QTY",
  "SAFETY STOCK METHOD",
  "SAFETY STOCK DAYS",
  "SAFETY STOCK QTY",
  "PRODUCTION LEAD TIME DAYS",
  "AGEING DAYS",
  "TRANSIT LEAD TIME DAYS",
  "TOTAL LEAD TIME DAYS",
  "MIN ORDER QTY",
  "ORDER MULTIPLE",
  "PLAN HORIZON DAYS",
  "DEFAULT",
  "CREATED BY",
];
const packsDefaultColumns = [
  "PRODUCT",
  "SUPPLIER",
  "FROM FACILITY",
  "TO FACILITY",
  "UOM",
  "QTY/PACK",
  "SCOPE",
  "WEIGHT",
  "WEIGHT UNITS",
  "LENGTH",
  "WIDTH",
  "HEIGHT",
  "DIMENSION UNITS",
  "CREATED BY",
  "CREATE DATE",
];

const initialState = {
  packs: { count: 0, results: [] },
  packsParams: { limit: 10, offset: 0 },

  products: { count: 0, results: [] },
  productsParams: { limit: 10, offset: 0 },
  productsSelection: [],

  productCategories: { count: 0, results: [] },
  productsCategoriesParams: { limit: 10, offset: 0 },
  productCategoriesSelection: [],
  downloadedProductCategories: [],
  productCategoryFields: [],

  productTags: { count: 0, results: [] },
  productsTagsParams: { limit: 10, offset: 0 },
  productTagsSelection: [],
  downloadedProductTags: [],
  productTagsFields: [],

  productStatus: [],
  productType: [],
  productFields: [],
  downloadedProducts: [],

  productPlans: { count: 0, results: [] },
  productPlansParams: { limit: 10, offset: 0 },
  downloadedProductPlans: [],

  productOrderFrequency: [],
  productPlanningPolicy: [],
  productStorageMethod: [],
  productReOrderPlanMethod: [],
  productAcquisitionCode: [],
  productStockLocation: [],
  productPlanFields: [],

  productAlias: { count: 0, results: [] },
  productAliasParams: { limit: 10, offset: 0 },
  productAliasSelection: [],
  productAliasFields: [],
  downloadedProductAlias: [],

  productsBasedSupplier: [],
  productsBasedWareCosting: [],
  productsBasedFromWarehouse: [],

  productsLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: MODULE_COLUMNS["product"],
      allViews: { "Default View": MODULE_COLUMNS["product"] },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  productCategoryLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: productCategoryDefaultColumns,
      allViews: {
        "Default View": productCategoryDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
  productTagLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: productTagDefaultColumns,
      allViews: {
        "Default View": productTagDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
  productAliasLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: productAliasDefaultColumns,
      allViews: {
        "Default View": productAliasDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
  productPlanLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: productPlanDefaultColumns,
      allViews: {
        "Default View": productPlanDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
  packLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: packsDefaultColumns,
      allViews: {
        "Default View": packsDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    addProduct: (state, action) => {
      state.products.count += 1;
      state.products.results = [action.payload, ...state.products.results];
    },
    createMultipleProductAlias: (state, action) => {
      state.productAlias.count += action.payload.length;
      state.productAlias.results = [...state.productAlias.results, ...action.payload];
    },
    createMultipleProductCategories: (state, action) => {
      state.productCategories.count += action.payload.length;
      state.productCategories.results = [...state.productCategories.results, ...action.payload];
    },
    createMultipleProductPlan: (state, action) => {
      state.productPlans.count += action.payload.length;
      state.productPlans.results = [...state.productPlans.results, ...action.payload];
    },
    createMultipleProducts: (state, action) => {
      state.products.count += action.payload.length;
      state.products.results = [...state.products.results, ...action.payload];
    },
    createMultipleProductTags: (state, action) => {
      state.productTags.count += action.payload.length;
      state.productTags.results = [...state.productTags.results, ...action.payload];
    },
    createProductAlias: (state, action) => {
      state.productAlias.count += action.payload.length;
      state.productAlias.results = [...state.productAlias.results, action.payload];
    },
    createProductCategory: (state, action) => {
      state.productCategories.count += action.payload.length;
      state.productCategories.results = [...state.productCategories.results, action.payload];
    },
    createProductPlan: (state, action) => {
      state.productPlans.count += action.payload.length;
      state.productPlans.results = [...state.productPlans.results, action.payload];
    },
    createProductTag: (state, action) => {
      state.productTags.count += action.payload.length;
      state.productTags.results = [...state.productTags.results, action.payload];
    },
    getDownloadedProductAlias: (state, action) => {
      state.downloadedProductAlias = action.payload;
    },
    getDownloadedProductCategories: (state, action) => {
      state.downloadedProductCategories = action.payload;
    },
    getDownloadedProductPlans: (state, action) => {
      state.downloadedProductPlans = action.payload;
    },
    getDownloadedProducts: (state, action) => {
      state.downloadedProducts = action.payload;
    },
    getDownloadedProductTags: (state, action) => {
      state.downloadedProductTags = action.payload;
    },
    getProductAcquisitionCode: (state, action) => {
      state.productAcquisitionCode = action.payload;
    },
    getProductAlias: (state, action) => {
      state.productAlias = action.payload;
    },
    getProductAliasFields: (state, action) => {
      state.productAliasFields = action.payload;
    },
    getProductBasedWareCosting: (state, action) => {
      state.productsBasedWareCosting = action.payload;
    },
    getProductCategories: (state, action) => {
      state.productCategories = action.payload;
    },
    getProductCategoryFields: (state, action) => {
      state.productCategoryFields = action.payload;
    },
    getProductFields: (state, action) => {
      state.productFields = action.payload;
    },
    getProductOrderFrequency: (state, action) => {
      state.productOrderFrequency = action.payload;
    },
    getProductPlanFields: (state, action) => {
      state.productPlanFields = action.payload;
    },
    getProductPlanningPolicy: (state, action) => {
      state.productPlanningPolicy = action.payload;
    },
    getProductPlans: (state, action) => {
      state.productPlans = action.payload;
    },
    getProductReOrderPlanMethod: (state, action) => {
      state.productReOrderPlanMethod = action.payload;
    },
    getProducts: (state, action) => {
      state.products = action.payload;
    },
    getProductsBasedFromWarehouse: (state, action) => {
      state.productsBasedFromWarehouse = action.payload;
    },
    getProductsBasedSupplier: (state, action) => {
      state.productsBasedSupplier = action.payload;
    },
    getProductStatus: (state, action) => {
      state.productStatus = action.payload;
    },
    getProductStockLocation: (state, action) => {
      state.productStockLocation = action.payload;
    },
    getProductStorageMethod: (state, action) => {
      state.productStorageMethod = action.payload;
    },
    getProductTags: (state, action) => {
      state.productTags = action.payload;
    },
    getProductTagsFields: (state, action) => {
      state.productTagsFields = action.payload;
    },
    getProductType: (state, action) => {
      state.productType = action.payload;
    },
    resetPacks: state => {
      state.packs = initialState.packs;
    },
    resetProductAcquisitionCode: state => {
      state.productAcquisitionCode = initialState.productAcquisitionCode;
    },
    resetProductAlias: (state, action) => {
      state.productAlias = initialState.productAlias;
    },
    resetProductAliasParams: state => {
      state.productAliasParams = { limit: state.productAliasParams.limit, offset: 0 };
    },
    resetProductBasedWareCosting: (state, action) => {
      state.productsBasedWareCosting = initialState.productsBasedWareCosting;
    },
    resetProductCategories: state => {
      state.productCategories = initialState.productCategories;
    },
    resetProductOrderFrequency: state => {
      state.productOrderFrequency = initialState.productOrderFrequency;
    },
    resetProductPlanningPolicy: state => {
      state.productPlanningPolicy = initialState.productPlanningPolicy;
    },
    resetProductPlans: state => {
      state.productPlans = initialState.productPlans;
    },
    resetProductPlansParams: state => {
      state.productPlansParams = { limit: state.productPlansParams.limit, offset: 0 };
    },
    resetProductReOrderPlanMethod: state => {
      state.productReOrderPlanMethod = initialState.productReOrderPlanMethod;
    },
    resetProducts: state => {
      state.products = initialState.products;
    },
    resetProductsBasedFromWarehouse: (state, action) => {
      state.productsBasedFromWarehouse = initialState.productsBasedFromWarehouse;
    },
    resetProductsBasedSupplier: (state, action) => {
      state.productsBasedSupplier = initialState.productsBasedSupplier;
    },
    resetProductsCategoriesParams: state => {
      state.productsCategoriesParams = { limit: state.productsCategoriesParams.limit, offset: 0 };
    },
    resetProductsParams: state => {
      state.productsParams = { limit: state.productsParams.limit, offset: 0 };
    },
    resetProductsSelection: state => {
      state.productsSelection = initialState.productsSelection;
    },
    resetProductsTagsParams: state => {
      state.productsTagsParams = { limit: state.productsTagsParams.limit, offset: 0 };
    },
    resetProductStatus: state => {
      state.productStatus = initialState.productStatus;
    },
    resetProductStockLocation: state => {
      state.productStockLocation = initialState.productStockLocation;
    },
    resetProductStorageMethod: state => {
      state.productStorageMethod = initialState.productStorageMethod;
    },
    resetProductTags: state => {
      state.productTags = initialState.productTags;
    },
    resetProductTagsSelection: state => {
      state.productTagsSelection = initialState.productTagsSelection;
    },
    resetProductType: state => {
      state.productType = initialState.productType;
    },
    setPacks: (state, action) => {
      const { count, results } = action.payload;
      state.packs = { ...state.packs, count, results };
    },
    setPacksParams: (state, action) => {
      state.packsParams = action.payload;
    },
    setProductAliasParams: (state, action) => {
      state.productAliasParams = action.payload;
    },
    setProductPlansParams: (state, action) => {
      state.productPlansParams = action.payload;
    },
    setProductsCategoriesParams: (state, action) => {
      state.productsCategoriesParams = action.payload;
    },
    setPackLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.packLayout = {
        ...state.packLayout,
        listView: {
          ...state.packLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.packLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductCategoryLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productCategoryLayout = {
        ...state.productCategoryLayout,
        listView: {
          ...state.productCategoryLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.productCategoryLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductTagLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productTagLayout = {
        ...state.productTagLayout,
        listView: {
          ...state.productTagLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.productTagLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductAliasLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productAliasLayout = {
        ...state.productAliasLayout,
        listView: {
          ...state.productAliasLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.productAliasLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductsLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productsLayout = {
        ...state.productsLayout,
        listView: {
          ...state.productsLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.productsLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductPlanLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.productPlanLayout = {
        ...state.productPlanLayout,
        listView: {
          ...state.productPlanLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.productPlanLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setProductsParams: (state, action) => {
      state.productsParams = action.payload;
    },
    setProductsSelection: (state, action) => {
      state.productsSelection = action.payload;
    },
    setProductAliasSelection: (state, action) => {
      state.productAliasSelection = action.payload;
    },
    setProductCategoriesSelection: (state, action) => {
      state.productCategoriesSelection = action.payload;
    },
    setProductsTagsParams: (state, action) => {
      state.productsTagsParams = action.payload;
    },
    setProductTagsSelection: (state, action) => {
      state.productTagsSelection = action.payload;
    },
    updateMultipleProductAlias: (state, action) => {
      const products = action.payload;
      products.forEach(product => {
        const index = state.productAlias.results.findIndex(item => item.id === product.id);
        if (index !== -1) {
          state.productAlias.results[index] = { ...state.productAlias.results[index], ...product };
        }
      });
    },
    updateMultipleProductCategories: (state, action) => {
      const productCategories = action.payload;
      productCategories.forEach(product => {
        const index = state.productCategories.results.findIndex(item => item.id === product.id);
        if (index !== -1) {
          state.productCategories.results[index] = {
            ...state.productCategories.results[index],
            ...product,
          };
        }
      });
    },
    updateMultipleProductPlans: (state, action) => {
      const productPlans = action.payload;
      productPlans.forEach(product => {
        const index = state.productPlans.results.findIndex(item => item.id === product.id);
        if (index !== -1) {
          state.productPlans.results[index] = { ...state.productPlans.results[index], ...product };
        }
      });
    },
    updateMultipleProducts: (state, action) => {
      const products = action.payload;
      products.forEach(product => {
        const index = state.products.results.findIndex(item => item.id === product.id);
        if (index !== -1) {
          state.products.results[index] = { ...state.products.results[index], ...product };
        }
      });
    },
    updateMultipleProductTags: (state, action) => {
      const productTags = action.payload;
      productTags.forEach(product => {
        const index = state.productTags.results.findIndex(item => item.id === product.id);
        if (index !== -1) {
          state.productTags.results[index] = { ...state.productTags.results[index], ...product };
        }
      });
    },
    updateProduct: (state, action) => {
      const index = state.products.results.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.products.results[index] = { ...state.products.results[index], ...action.payload };
      }
    },
    updateProductAlias: (state, action) => {
      const index = state.productAlias.results.findIndex(file => file.id === action.payload.id);
      if (index !== -1) {
        state.productAlias.results[index] = {
          ...state.productAlias.results[index],
          ...action.payload,
        };
      }
    },
    updateProductCategory: (state, action) => {
      const index = state.productCategories.results.findIndex(
        item => item.id === action.payload.id,
      );
      if (index !== -1) {
        state.productCategories.results[index] = {
          ...state.productCategories.results[index],
          ...action.payload,
        };
      }
    },

    updateProductCategoryParams: (state, action) => {
      state.productsCategoriesParams = { ...state.productsCategoriesParams, ...action.payload };
    },
    updateProductPlan: (state, action) => {
      const index = state.productPlans.results.findIndex(file => file.id === action.payload.id);
      if (index !== -1) {
        state.productPlans.results[index] = {
          ...state.productPlans.results[index],
          ...action.payload,
        };
      }
    },
    updateProductsParams: (state, action) => {
      state.productsParams = { ...state.productsParams, ...action.payload };
    },
    updateProductTag: (state, action) => {
      const index = state.productTags.results.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.productTags.results[index] = {
          ...state.productTags.results[index],
          ...action.payload,
        };
      }
    },

    updatePackParams: (state, action) => {
      state.packsParams = { ...state.packsParams, ...action.payload };
    },
    updateProductTagParams: (state, action) => {
      state.productsTagsParams = { ...state.productsTagsParams, ...action.payload };
    },
    updateProductAliasParams: (state, action) => {
      state.productAliasParams = { ...state.productAliasParams, ...action.payload };
    },
    updateProductPlanParams: (state, action) => {
      if (action.payload?.replace) {
        const { replace, ...rest } = action.payload;
        state.productPlansParams = rest;
      } else {
        state.productPlansParams = { ...state.productPlansParams, ...action.payload };
      }
    },
  },
});

export const {
  addProduct,
  createMultipleProductAlias,
  createMultipleProductCategories,
  createMultipleProductPlan,
  createMultipleProducts,
  createMultipleProductTags,
  createProductAlias,
  createProductCategory,
  createProductPlan,
  createProductTag,
  getDownloadedProductAlias,
  getDownloadedProductCategories,
  getDownloadedProductPlans,
  getDownloadedProducts,
  getDownloadedProductTags,
  getProductAcquisitionCode,
  getProductAlias,
  getProductAliasFields,
  getProductBasedWareCosting,
  getProductCategories,
  getProductCategoryFields,
  getProductFields,
  getProductOrderFrequency,
  getProductPlanFields,
  getProductPlanningPolicy,
  getProductPlans,
  getProductReOrderPlanMethod,
  getProducts,
  getProductsBasedFromWarehouse,
  getProductsBasedSupplier,
  getProductStatus,
  getProductStockLocation,
  getProductStorageMethod,
  getProductTags,
  getProductTagsFields,
  getProductType,
  resetPacks,
  resetProductAcquisitionCode,
  resetProductAlias,
  resetProductAliasParams,
  resetProductBasedWareCosting,
  resetProductCategories,
  resetProductOrderFrequency,
  resetProductPlanningPolicy,
  resetProductPlans,
  resetProductPlansParams,
  resetProductReOrderPlanMethod,
  resetProducts,
  resetProductsBasedFromWarehouse,
  resetProductsBasedSupplier,
  resetProductsCategoriesParams,
  resetProductsParams,
  resetProductsSelection,
  setProductAliasSelection,
  resetProductsTagsParams,
  resetProductStatus,
  resetProductStockLocation,
  resetProductStorageMethod,
  resetProductTags,
  resetProductTagsSelection,
  resetProductType,
  setPacks,
  setPacksParams,
  setProductAliasParams,
  setProductPlansParams,
  setProductsCategoriesParams,
  setPackLayoutAllViews,
  setProductCategoryLayoutAllViews,
  setProductTagLayoutAllViews,
  setProductAliasLayoutAllViews,
  setProductsLayoutAllViews,
  setProductPlanLayoutAllViews,
  setProductsParams,
  setProductsSelection,
  setProductCategoriesSelection,
  setProductsTagsParams,
  setProductTagsSelection,
  updateMultipleProductAlias,
  updateMultipleProductCategories,
  updateMultipleProductPlans,
  updateMultipleProducts,
  updateMultipleProductTags,
  updateProduct,
  updateProductAlias,
  updateProductCategory,
  updateProductPlan,
  updateProductsParams,
  updateProductCategoryParams,
  updateProductTag,
  updatePackParams,
  updateProductAliasParams,
  updateProductTagParams,
  updateProductPlanParams,
} = productSlice.actions;

export default productSlice.reducer;
